import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lot-notations-button',
  templateUrl: './lot-notations-button.component.html',
  styleUrls: ['./lot-notations-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotNotationsButtonComponent {
  @Input() fullSize = false;

  get link(): string {
    return `https://${environment.fullDomain}/article/sheet`;
  }
}
